// extracted by mini-css-extract-plugin
export default {"loadingSection":"ProtectedRoute_loadingSection__kEbqR","loader":"ProtectedRoute_loader__1BSnQ"};